export const showChat = () => {
    window.$zopim.livechat.window.show();
};
